export default __webpack_public_path__ + "static/media/checked-icn.50c764c2.svg";